import {Trans} from '@lingui/macro';
import React, {FC, useMemo} from 'react';

import {TooltipCoordinator} from '../../../../../libs/shared/ui/src/components/tooltips/tooltipCoordinator';
import {useUserTheme} from '../../../../../libs/shared/ui/src/theme/userThemeProvider';
import {TooltipIconWithHover} from '../../../../analytics/components/reportElements/tooltips/analyticsTooltips';
import {getParameters} from '../../../editors/expressions/expressionInferHelpers';
import {RuleMultilineParameterCard} from '../ruleMultilineParameterCard';
import {AtomCardProps} from './atomCard';
import {AtomIcon} from './atomIcon';
import {AtomTitle} from './atomTitle';
import {StyledParameterLineDiv, StyledParameterTitleLineDiv} from './parameterLine';
import {AtomParameterPicker} from './pickers/atomParameterPicker';

export const TagAtomCard: FC<AtomCardProps> = (props) => {
  const theme = useUserTheme();
  const {atom, isDisabled, onUpdateAtom, onCancel} = props;
  const [tagParam, parentTagParam, showInCellsParam, forceCreateParam] = getParameters(atom);

  const collapsableParameters = useMemo(
    () => [
      <StyledParameterLineDiv key="nestunder">
        <StyledParameterTitleLineDiv>
          <span>
            <Trans id="rule-expressions-nesttagunder">Nest tag under</Trans>
          </span>
          <TooltipCoordinator
            iconColor={theme.greys.shade50}
            render={() => (
              <Trans id="expressions-param-nesttagunder-tooltip">
                You can nest at most 100 tags under the same parent tag.
              </Trans>
            )}
          >
            <TooltipIconWithHover />
          </TooltipCoordinator>
        </StyledParameterTitleLineDiv>
        <AtomParameterPicker
          parameter={parentTagParam}
          atom={atom}
          isDisabled={isDisabled}
          onUpdate={onUpdateAtom}
        />
      </StyledParameterLineDiv>,
      <StyledParameterLineDiv key="showincell">
        <AtomParameterPicker
          parameter={showInCellsParam}
          atom={atom}
          isDisabled={isDisabled}
          onUpdate={onUpdateAtom}
        />
      </StyledParameterLineDiv>,
    ],
    [parentTagParam, atom, onUpdateAtom, isDisabled, showInCellsParam],
  );

  return (
    <RuleMultilineParameterCard
      errorMessage={atom.errorMessage}
      icon={<AtomIcon atom={atom} />}
      title={<AtomTitle atom={atom} />}
      onCancel={onCancel}
      collapsableParameters={collapsableParameters}
    >
      <StyledParameterLineDiv>
        <AtomParameterPicker
          parameter={tagParam}
          atom={atom}
          isDisabled={isDisabled}
          onUpdate={onUpdateAtom}
        />
      </StyledParameterLineDiv>

      <StyledParameterLineDiv>
        <AtomParameterPicker
          parameter={forceCreateParam}
          atom={atom}
          isDisabled={isDisabled}
          onUpdate={onUpdateAtom}
        />
      </StyledParameterLineDiv>
    </RuleMultilineParameterCard>
  );
};
